import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PROJECTS_DATA } from '../data/projects';
import { SkeletonBlock } from '../components/common/SkeletonBlock';

const HomeImpl = ({ accent, mood, isResolving }) => (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="relative min-h-[100svh] flex flex-col justify-start sm:justify-center mt-20 sm:mt-0 px-4 sm:px-8 lg:px-24"
    >
    <AnimatePresence mode="wait">
      {isResolving ? (
        <div key="skeleton" className="max-w-4xl space-y-8">
          <SkeletonBlock className="h-6 w-48 rounded-full" />
          <div className="space-y-4">
            <SkeletonBlock className="h-24 w-full max-w-2xl rounded-2xl" />
            <SkeletonBlock className="h-24 w-3/4 rounded-2xl" />
          </div>
          <SkeletonBlock className="h-6 w-full max-w-xl rounded-full" />
          <div className="flex gap-12">
            <SkeletonBlock className="h-16 w-32 rounded-xl" />
            <SkeletonBlock className="h-16 w-32 rounded-xl" />
            <SkeletonBlock className="h-16 w-32 rounded-xl" />
          </div>
        </div>
      ) : (
        <motion.div key="content" initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="max-w-4xl relative z-10">
          <motion.span initial={{ letterSpacing: '0.5em', opacity: 0 }} animate={{ letterSpacing: '0.4em', opacity: 1 }} className="mt-4 sm:mt-10 text-xs uppercase font-black text-white/40 mb-4 sm:mb-6 block">CREATING DIGITAL EXPERIENCES</motion.span>
          <h1 className="text-5xl sm:text-7xl lg:text-9xl font-black italic text-white leading-[0.85] tracking-tighter mb-8">
            Hi , I’m <br />
            <span style={{ color: accent.color }}>NIKHIL</span>
          </h1>

          <p className="text-sm uppercase tracking-[0.4em] text-white/40 mb-6">
          React • Node • JavaScript • UI/UX Design
          </p>

          <p className="text-base sm:text-lg lg:text-2xl text-white/50 max-w-xl font-medium leading-relaxed mb-12 border-l-4 pl-8" style={{ borderColor: accent.color }}>
          Full-stack developer focused on building performant web apps, immersive UI experiences, and real-world products using React, Node, and modern tooling.
          </p>
          <div className="flex flex-wrap gap-12 items-center">
            <div className="flex flex-col">
              <span className="text-[10px] uppercase text-white/20 font-black tracking-widest mb-1">PROJECTS</span>
              <span className="text-4xl font-black italic" style={{ color: accent.color }}>{PROJECTS_DATA.length}+</span>
            </div>

            <div className="flex flex-col">
              <span className="text-[10px] uppercase text-white/20 font-black tracking-widest mb-1">EXPERIENCE</span>
              <span className="text-4xl font-black italic text-white">2+ YEARS</span>
            </div>

            <div className="flex flex-col">
              <span className="text-[10px] uppercase text-white/20 font-black tracking-widest mb-1">ROLE</span>
              <span className="text-4xl font-black italic text-white">FULL STACK</span>
            </div>
          </div>

        </motion.div>
      )}
    </AnimatePresence>
  </motion.div>
);

export const Home = React.memo(HomeImpl);
